
export default {
  props: {
    gridElements: Array,
  },
  methods: {
    getImagePath(imagePath) {
      return `/assets/imgs/${imagePath}`;
    },
  },
};
